import { useCallback } from 'react';
import { useLogger } from 'crm-object-board-core/logger';
import { useHasTags } from 'crm-object-board-core/user';
import { EditBoardSettingsPanel } from 'crm-pipeline-board-settings-lib/EditBoardSettingsPanel';
import { useTriggerOverlay } from '../handlers/useTriggerOverlay';
import { useCloseOverlay } from '../overlay/OverlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const BoardPanel = props => {
  const logger = useLogger();
  const hasTags = useHasTags();
  const trackChanges = useCallback(settings => {
    logger.log({
      key: 'saveBoardPreferences',
      metadata: {
        settings
      }
    });
  }, [logger]);
  const closeOverlay = useCloseOverlay();
  return /*#__PURE__*/_jsx(EditBoardSettingsPanel, {
    onClose: closeOverlay,
    defaultTabId: props.tabId || 'CARDS_TAB_ID',
    hasTags: hasTags,
    onSaveComplete: trackChanges
  });
};
export const useOpenBoardSettingsPanel = () => {
  const trigger = useTriggerOverlay();
  return useCallback(tabId => {
    const overlay = () => /*#__PURE__*/_jsx(BoardPanel, {
      tabId: tabId
    });
    trigger(overlay);
  }, [trigger]);
};